import { Bell, BellOff, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { usePushNotifications } from "@/lib/push";
import { isStandalone } from "@/lib/pwa";

const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const PushToggle = () => {
  const { state, enable, disable } = usePushNotifications();
  const run = (fn, msg) => async () => {
    try {
      await fn();
      if (msg) toast.success(msg);
    } catch {
      toast.error("Impossibile attivare le notifiche su questo dispositivo");
    }
  };

  if (state === "loading") return <Loader2 className="mx-3.5 h-4 w-4 animate-spin text-slate-500" />;
  if (state === "unsupported")
    return (
      <p data-testid="push-unsupported" className="px-3.5 text-xs text-slate-500">
        {isIOS() && !isStandalone() ? "Su iPhone installa prima l'app (Condividi → Aggiungi alla schermata Home) per ricevere le notifiche." : "Notifiche non supportate da questo browser."}
      </p>
    );
  if (state === "denied") return <p data-testid="push-denied" className="px-3.5 text-xs text-slate-500">Notifiche bloccate: riattivale dalle impostazioni del browser.</p>;
  const on = state === "on";
  return (
    <button
      data-testid="push-toggle-button"
      onClick={on ? run(disable, "Notifiche disattivate") : run(enable, "Notifiche attivate: riceverai un avviso per ogni nuovo lead")}
      className={`flex w-full items-center gap-3 whitespace-nowrap rounded-xl px-3.5 py-2.5 text-sm font-medium transition-colors ${on ? "bg-emerald-500 text-slate-900" : "text-slate-300 hover:bg-slate-800/60 hover:text-white"}`}
    >
      {on ? <Bell className="h-4 w-4" /> : <BellOff className="h-4 w-4" />}
      {on ? "Notifiche lead attive" : "Attiva notifiche lead"}
    </button>
  );
};
